import { cashnator } from "../utils/functions";
import { FIELD_LABELS, PRIORITY_LABELS, PRODUCT_LABELS } from "./pricingMeta";

const RATE_FIELDS = ["additionalRate", "discountPerItem", "maxDiscount", "handlingFeeRate"];

// Compartilhado entre o modal de publicação e o histórico: traduz um path de
// diff ("products.premium.baseCents") para rótulo humano e formata os valores.
export const describePath = (path) => {
    const segments = String(path).split(".");
    const [top, key] = segments;
    const field = segments[segments.length - 1];
    const fieldLabel = FIELD_LABELS[field] || field;

    if (top === "products") {
        const itemLabel = PRODUCT_LABELS[key] || key;
        return `${itemLabel} — ${fieldLabel}`;
    }
    if (top === "priorities") {
        const itemLabel = PRIORITY_LABELS[key] || key;
        return `${itemLabel} — ${fieldLabel}`;
    }
    return fieldLabel;
};

export const formatDiffValue = (path, value) => {
    const segments = String(path).split(".");
    const field = segments[segments.length - 1];

    if (field === "active") {
        return value ? "Sim" : "Não";
    }
    if (RATE_FIELDS.includes(field)) {
        return `${((Number(value) || 0) * 100).toFixed(2)}%`;
    }
    if (field.endsWith("Cents")) {
        return cashnator(value ?? 0) || "R$0,00";
    }
    return String(value);
};
